import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class FeedbackTitle extends PrimitiveValueObject<string> {
  static create(value: string): FeedbackTitle {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new FeedbackTitle(value);
  }
}
